import type { StorageProvider } from '../../storage/StorageProvider';
import type { WorkerBridgeWorker } from './WorkerBridgeWorker';

export function createBridgeStorageProvider(worker: WorkerBridgeWorker): StorageProvider {
  return {
    get(key: string): Promise<Uint8Array | null> {
      return worker.sendHostRequest('host.storage.get', [key]).then(result => {
        if (result === null) return null;
        if (result instanceof Object && 'data' in (result as Record<string, unknown>)) {
          return new Uint8Array((result as { data: number[] }).data);
        }
        return null;
      });
    },
    set(key: string, data: Uint8Array): Promise<void> {
      return worker.sendHostRequest('host.storage.set', [key, Array.from(data)]).then(() => undefined);
    },
    delete(key: string): Promise<void> {
      return worker.sendHostRequest('host.storage.delete', [key]).then(() => undefined);
    },
    list(prefix: string): Promise<string[]> {
      return worker.sendHostRequest('host.storage.list', [prefix]) as Promise<string[]>;
    },
    isAvailable(): boolean {
      return true;
    },
    getStorageType(): 'indexeddb' | 'memory' {
      return 'memory';
    },
  };
}
